/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                var commonManager = new CommonManager.getInstance(),
                    menuManager = new MenuManager.getInstance(),
                    coursesManager = new CoursesManager.getInstance(),
                    coursesStaticManager = new CoursesStaticManager.getInstance(),
                    membersRowManager = new MembersRowManager.getInstance(),
                    newsCarouselManager = new NewsCarouselManager.getInstance(),
                    publicationsCarouselManager = new PublicationsCarouselManager.getInstance(),
                    certificationsCarouselManager = new CertificationsCarouselManager.getInstance(),
                    colaborationsCarouselManager = new ColaborationsCarouselManager.getInstance(),
                    bulletinsCarouselManager = new BulletinsCarouselManager.getInstance(),
                    highlightsCarouselManager = new HighlightsCarouselManager.getInstance(),
                    goToManager = new GoToManager.getInstance(),
                    bulletinManager = new BulletinsManager.getInstance(),
                    dictionaryManager = new DictionaryManager.getInstance(),
                    formsManager = new FormsManager.getInstance(),
                    contestsManager = new ContestsManager.getInstance(),
                    referencesManager = new ReferencesManager.getInstance(),
                    reflexionaManager = new ReflexionaManager.getInstance();

                    tabsManager = new TabsManager.getInstance();
                    progressManager = new ProgressManager.getInstance();

                    maquetaManager = new MaquetaManager.getInstance();


                commonManager.init();
                menuManager.init();
                coursesManager.init();
                coursesStaticManager.init();
                membersRowManager.init();
                newsCarouselManager.init();
                publicationsCarouselManager.init();
                certificationsCarouselManager.init();
                colaborationsCarouselManager.init();
                bulletinsCarouselManager.init();
                highlightsCarouselManager.init();
                goToManager.init();
                bulletinManager.init();
                dictionaryManager.init();
                contestsManager.init();
                referencesManager.init();
                reflexionaManager.init();

                formsManager.init();

                tabsManager.init();
                progressManager.init();

                maquetaManager.init();
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },

        // About us page, note the change from about-us to about_us.
        'maqueta_nueva_web': {
            init: function() {
                // JavaScript to be fired on the about us page
                console.log('HOLA....');
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    // Bulletin Clamp
    var bulletinTitle = document.querySelectorAll('.bulletin__title-link');
    var bulletinText = document.querySelectorAll('.bulletin__text');
    
    for ( i=0; i < bulletinTitle.length; i++ ) {
        $clamp(bulletinTitle[i], {clamp: 6});
    }

    for ( i=0; i < bulletinText.length; i++ ) {
        $clamp(bulletinText[i], {clamp: 9});
    }


    // Map Clients
    var $points = jQuery('.js-point');

    $points.on("click", function() {
        $points.not(this).removeClass('active');
        $(this).toggleClass('active');
    });

    // show/hide bulletin form filters date
    var filterDateBtn = document.querySelector('.js-filter-bulletin-date--btn');
    var filterDate = document.querySelectorAll('.js-filter-bulletin-date');



    if (filterDateBtn) {
        filterDateBtn.addEventListener('click', function () {

            /*
             if (filterDateBtn.getAttribute('data-text-swap') == filterDateBtn.innerHTML) {
             filterDateBtn.innerHTML = filterDateBtn.getAttribute('data-text-original');
             } else {
             filterDateBtn.setAttribute('data-text-original', filterDateBtn.innerHTML);
             filterDateBtn.innerHTML = filterDateBtn.getAttribute('data-text-swap');
             }
             */

            this.closest('.col-12.d-md-none').classList.add('d-none');

            var filterBulletinForm = document.querySelector('.js-form-filter-bulletin');
            filterBulletinForm.classList.add('u-mb-m');

            for (i = 0; i < filterDate.length; i++) {
                filterDate[i].classList.toggle('d-none');
            }

        }, false);
    }


})(jQuery); // Fully reference jQuery after this point.
